import { ChangeDetectionStrategy } from '@angular/core';
import { Component, input, OnInit, signal, inject, output } from '@angular/core';
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { MultiSelectModule } from "primeng/multiselect";
import { TooltipModule } from "primeng/tooltip";
import { ResolutionTemplate } from 'src/app/users/proyectos/interfaces/resolution-template.interface';
import { ProyectoService } from 'src/app/users/proyectos/services/proyecto.service';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { take } from 'rxjs';

@Component({
  selector: 'app-descargar-plantilla',
  standalone: true,
  providers: [MessageService],
  imports: [
    DialogModule,
    DropdownModule,
    FormsModule,
    MultiSelectModule,
    TooltipModule,
    CommonModule,
    ToastModule,
    ButtonModule,
    ToastModule
  ],
  templateUrl: './descargar-plantilla.component.html',
  styleUrl: './descargar-plantilla.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescargarPlantillaComponent implements OnInit {
  isVisible = input(false);
  dialogClosed = output<boolean>();

  private proyectoService = inject(ProyectoService);
  private messageService = inject(MessageService);

  availableTemplates = signal<ResolutionTemplate[]>([]);
  selectedTemplate = signal<ResolutionTemplate | null>(null);

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.proyectoService.getResolutionTemplates()
      .pipe(
        take(1)
      )
      .subscribe({
        next: (templates) => {
          this.availableTemplates.set(templates);
        },
        error: (error) => {
          console.error('Error al cargar las plantillas de resolución:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las plantillas.' });
        },
      });
  }

  close(emitEvent: boolean): void {
    this.selectedTemplate.set(null);
    this.dialogClosed.emit(true);
  }

  handleTemplateSelection(event: { value: ResolutionTemplate | null }): void {
    this.selectedTemplate.set(event.value);
  }

  downloadSelectedTemplate(): void {
    const currentTemplate = this.selectedTemplate();
    if (!currentTemplate || !currentTemplate.id) {
      this.messageService.add({ severity: 'warn', summary: 'Advertencia', detail: 'Por favor, seleccione una plantilla para descargar.' });
      return;
    }

    this.proyectoService.getResolutioTemplateById(String(currentTemplate.id)).subscribe({
      next: (fileBlob: Blob) => {
        const url = window.URL.createObjectURL(fileBlob);
        const a = document.createElement('a');
        a.href = url;
        const fileName = currentTemplate.nombre ? `${currentTemplate.nombre}.docx` : 'plantilla_resolucion.docx';
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.close(true);
      },
      error: (error) => {
        console.error('Error al descargar la plantilla de resolución:', error);
        this.messageService.add({ severity: 'error', summary: 'Error de Descarga', detail: 'No se pudo descargar la plantilla.' });
      }
    });
  }

}
